<template>
    <div class="tier__features" :class="stateObj">
        <!--<a href="#" class="tier__view_link" v-on:click="togglePanel">View features<span></span></a>-->

        <div class="tier__features_panel">
            <p v-html="$t('message.features.disclaimer1')"></p>
        </div>
    </div>
</template>

<script>
    export default{
        name: 'features',
        data(){
            return {
                stateObj: {
                    open: false
                }
            }
        },
        methods:{
            togglePanel(){
                this.stateObj.open = !this.stateObj.open
            }
        }
    }
</script>
